import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { PopoverService } from '../popover/popover.service';
import { ToolbarUserDropdownComponent } from './toolbar-user-dropdown/toolbar-user-dropdown.component';
import icPerson from '@iconify/icons-ic/twotone-person';
import theme from '../../utils/tailwindcss';
import { AppService, CURRENT_EMPLOYER, CURRENT_USER } from 'src/@core/services/app.service';
import { entityTypes, roles } from 'src/app/shared/helpers/roles-permissions';

@Component({
  selector: 'codemiro-toolbar-user',
  templateUrl: './toolbar-user.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolbarUserComponent implements OnInit {

  dropdownOpen: boolean;
  icPerson = icPerson;
  profile = null;
  theme = theme;
  employerDetails: any = null;
  roles = roles;
  entityTypes = entityTypes;
  initials: string = '';

  constructor(
    private app: AppService,
    private popover: PopoverService,
    private cd: ChangeDetectorRef) { }

  ngOnInit() {
    if (this.app.getCurrentAccount()) {
      this.profile = this.app.getCurrentAccount().user_details;
    }
    this.employerDetails = JSON.parse(localStorage.getItem(CURRENT_EMPLOYER))


    this.profile = this.app.getCurrentAccount();
    if (this.profile) {
      const fullName = this.profile.entity.entityMeta.name || '';
      console.log("fullName", fullName);
      const nameParts = fullName.trim().split(' ');
      this.initials = nameParts.length >= 2
        ? nameParts[0][0].toUpperCase() + nameParts[1][0].toUpperCase()
        : fullName.substring(0, 2).toUpperCase();
    }
  }

  showPopover(originRef: HTMLElement) {
    this.dropdownOpen = true;
    this.cd.markForCheck();

    const popoverRef = this.popover.open({
      content: ToolbarUserDropdownComponent,
      origin: originRef,
      offsetY: 12,
      position: [
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'center',
          overlayY: 'bottom'
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top',
        },
      ]
    });

    popoverRef.afterClosed$.subscribe(() => {
      this.dropdownOpen = false;
      this.cd.markForCheck();
    });
  }
}
